import React from "react";
import styled from "styled-components";
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Tag,
  Select,
  Spin,
  Divider,
  Card,
  Typography,
  Tabs,
  AutoComplete,
  Upload,
  Checkbox,
  Space,
  InputNumber,
  Switch,
  Tooltip,
} from "antd";
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
} from "@ant-design/icons";
import { ButtonSquare } from "src/components/elements/Button";
import dropImage from "src/static/icons/carImageUpload/placeholder.png";
import Resizer from "react-image-file-resizer";
import { Form } from "@ant-design/compatible";
import Notify from "src/components/meta/Notification";
import Highlighter from "react-highlight-words";
import "braft-editor/dist/index.css";
import BraftEditor from "braft-editor";
import Editor from "react-quill-antd";
import "react-quill-antd/dist/index.css";

const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;

const { TabPane } = Tabs;

const { Option } = Select;
const Cards = styled(Card)`
  .ant-card-body {
    display: none !important;
  }
`;
const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #8898aa !important;
    background: #f1f1f1 !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;
    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: "";
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 1.5em !important;
    width: 1.5em !important;
  }
`;
const StyledInput = styled(Input)`
margin-bottom:0 !important;
  padding-left: 1.2em !important;
  height: 47px !important;
  // border-right-width: 0px !important;
    box-shadow:none !important;
  background-color: white!important;
  background-image: none;
  border: 1px solid lightgrey !important;
  border-bottom: 1px solid lightgrey !important;
  border-radius: 0px;
  color: black!important;
  font-size: 12px !important;
  //box-shadow: rgba(0, 0, 0, 0.11) 2px 8px 13px 5px !important;
  :placeholder {
    color: lightgrey !important;
  }
  :hover {
    border-color: color: "white",!important;
    // border-right-width: 0px !important;
    box-shadow:none !important;
}
  :active{
    border-color:#1890ff!important;
    // border-right-width: 0px !important;
     box-shadow:none !important;
   
  }
  :focus{
    border-color:#1890ff!important;
    // border-right-width: 0px !important;
     box-shadow:none !important;
   
  }
  }
`;
const StyledInputNumber = styled(InputNumber)`
padding: 8px 0px;
 margin-bottom:0 !important;
 font-size: 12px !important;
  padding-left: 1.2em !important;
  height: 47px !important;
  // border-right-width: 0px !important;
    box-shadow:none !important;
  background-color: white!important;
  background-image: none;
  border: 1px solid lightgrey !important;
  border-bottom: 1px solid lightgrey !important;
  border-radius: 0px;
  color: black!important;
  //box-shadow: rgba(0, 0, 0, 0.11) 2px 8px 13px 5px !important;
  }
`;
const StyledSelect = styled(Select)`
font-size: 12px !important;
.ant-select-arrow {
  color: black !important;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  position: relative;
  background-color: transparent !important;
  color: black !important;
  border: 1px solid #e9e9e9;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
  .ant-select-multiple .ant-select-selector {
    height: 45px !important;
  }
  border: 1px solid lightgrey !important;
  border-radius: 0px !important;
  height: 47px !important;
  box-shadow: none !important;
  :hover {
    border-color:#1890ff!important;
    border-radius: 0px !important;
    box-shadow: none !important;
  }
  :active {
    border-color: grey !impo  border-radius: 0px !important;rtant;

    box-shadow: none !important;
  }
  :focus {
    border-color:#1890ff!important;
 
    box-shadow: none !important;
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
      border-color:#1890ff!important;
   
    outline: 0;
    box-shadow: none !important;
  }
`;
function callback(key) {
  console.log(key);
}
function onChange(e) {
  console.log(`checked = ${e.target.checked}`);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class AddStockForm extends React.Component {
  state = {
    manualInput: this.props.editStock
      ? this.props.editStock.manualInput
      : false,
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    fileList: [],
    stockNumbers: [],
    years: [],
    makes: [],
    variants: [],
    models: [],
    mileages: [],
    retailIncs: [],
    intColours: [],
    extColours: [],
    capacityCCs: [],
    bodyTypes: [],
    engineSizes: [],
    unladenWeights: [],
    vehicleDrives: [],
    axles: [],
    doors: [],
    cylinders: [],
    passengers: [],
    vehicleStockNumbers: [],
    vehicleStockNumber: undefined,
    intColour: undefined,
    extColour: undefined,
    passenger: undefined,
    retailPriceIncl: undefined,
    cylinder: undefined,
    unladenWeight: undefined,
    axle: undefined,
    vehicleDrive: undefined,
    engineSize: undefined,
    bodyType: undefined,
    capacityCC: undefined,
    stockNumber: undefined,
    modelYear: undefined,
    make: undefined,
    mileage: undefined,
    series: undefined,
    branchImage: undefined,
    frontLeftImage: undefined,
    frontImage: undefined,
    frontRightImage: undefined,
    rightSideImage: undefined,
    wheelsImage: undefined,
    backRightImage: undefined,
    backImage: undefined,
    backLeftImage: undefined,
    leftSideImage: undefined,
    bootImage: undefined,
    frontSeatImage: undefined,
    backSeatImage: undefined,
    dashPassengerImage: undefined,
    dashDriverImage: undefined,
    dashDriverSideImage: undefined,
    radioImage: undefined,
    radioCloseImage: undefined,
    gearsImage: undefined,
    steeringImage: undefined,
    spareKeyImage: undefined,
    disabled: true,
    curDT: new Date().toLocaleString(),
  };

  toggleDisabled = () => {
    this.setState({
      disabled: !this.state.disabled,
    });
  };
  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };
  handleChange = ({ fileList }) => this.setState({ fileList });
  selectManual = checked => {
    this.setState({
      manualInput: !this.state.manualInput,
    });
  };

  componentWillMount = () => {
    if (this.props.editStock) {
      this.setState({
        branchImage: this.props.editStock.branchImage,
        frontLeftImage: this.props.editStock.frontLeftImage,
        frontImage: this.props.editStock.frontImage,
        frontRightImage: this.props.editStock.frontRightImage,
        rightSideImage: this.props.editStock.rightSideImage,
        wheelsImage: this.props.editStock.wheelsImage,
        backRightImage: this.props.editStock.backRightImage,
        backImage: this.props.editStock.backImage,
        backLeftImage: this.props.editStock.backLeftImage,
        leftSideImage: this.props.editStock.leftSideImage,
        bootImage: this.props.editStock.bootImage,
        frontSeatImage: this.props.editStock.frontSeatImage,
        backSeatImage: this.props.editStock.backSeatImage,
        dashPassengerImage: this.props.editStock.dashPassengerImage,
        dashDriverImage: this.props.editStock.dashDriverImage,
        dashDriverSideImage: this.props.editStock.dashDriverSideImage,
        radioImage: this.props.editStock.radioImage,
        radioCloseImage: this.props.editStock.radioCloseImage,
        gearsImage: this.props.editStock.gearsImage,
        steeringImage: this.props.editStock.steeringImage,
        spareKeyImage: this.props.editStock.spareKeyImage,
      });
    }
  };
  handleBranchImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        branchImage: imageUrl,
      });
    });
  };
  handleFrontLeftImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontLeftImage: imageUrl,
      });
    });
  };
  handleFrontImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontImage: imageUrl,
      });
    });
  };
  handleFrontRightImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontRightImage: imageUrl,
      });
    });
  };
  handleRightSideImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        rightSideImage: imageUrl,
      });
    });
  };
  handleRadioCloseImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        radioCloseImage: imageUrl,
      });
    });
  };
  handleWheelsImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        wheelsImage: imageUrl,
      });
    });
  };
  handleBackRightImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backRightImage: imageUrl,
      });
    });
  };
  handleBackImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backImage: imageUrl,
      });
    });
  };
  handleBackLeftImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backLeftImage: imageUrl,
      });
    });
  };
  handleLeftSideImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        leftSideImage: imageUrl,
      });
    });
  };
  handleBootImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        bootImage: imageUrl,
      });
    });
  };
  handleFrontSeatImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontSeatImage: imageUrl,
      });
    });
  };
  handleBackSeatImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backSeatImage: imageUrl,
      });
    });
  };
  handleDashPassengerImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        dashPassengerImage: imageUrl,
      });
    });
  };
  handleDashDriverImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        dashDriverImage: imageUrl,
      });
    });
  };
  handleDashDriverSideImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        dashDriverSideImage: imageUrl,
      });
    });
  };
  handleRadioImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        radioImage: imageUrl,
      });
    });
  };
  handleRadioCloseImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        radioCloseImage: imageUrl,
      });
    });
  };
  handleGearsImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        gearsImage: imageUrl,
      });
    });
  };
  handleSteeringImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        steeringImage: imageUrl,
      });
    });
  };
  handleSpareKeyImage = info => {
    this.setState({
      loading: true,
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        spareKeyImage: imageUrl,
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify("error", window.i18n.translate("ImageSmaller"));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 800, 800, "JPG", 100, 0, uri => {
      callback(uri);
    });
  };

  render() {
    const controls = [
      "bold",
      "italic",
      "underline",
      "text-color",
      "separator",
      "link",
      "separator",
      "media",
    ];
    const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    return (
      <Form layout="vertical">
       <Row>
         {/* Cover Type (hospitalCover) */}
         <Col xs={12} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Cover Type</span>}>
             {this.props.form.getFieldDecorator("hospitalCover", {
               rules: [{ required: false, message: "Cover Type is required" }],
               initialValue: this.props.editStock ? this.props.editStock.hospitalCover : "",
             })(<StyledInput disabled size="large" placeholder="" />)}
           </FormItem>
         </Col>
     
         {/* Lead Type (keep) */}
         {/* <Col xs={12} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Lead Type</span>}>
             {this.props.form.getFieldDecorator("leadDepartment", {
               rules: [{ required: false, message: "Lead Type is required" }],
               initialValue: this.props.editStock ? this.props.editStock.condition : "QUOTE REQUEST",
             })(
               <StyledSelect>
                 <Option key={"QUOTE REQUEST"} value={"QUOTE REQUEST"}>QUOTE REQUEST</Option>
                 <Option key={"CALLBACK LEAD"} value={"CALLBACK LEAD"}>CALLBACK LEAD</Option>
               </StyledSelect>
             )}
           </FormItem>
         </Col> */}
     
         {/* Status (keep) */}
         <Col xs={12} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Status</span>}>
             {this.props.form.getFieldDecorator("status", {
               rules: [{ required: false, message: "Status is required" }],
               initialValue: this.props.editStock ? this.props.editStock.status : "No Action",
             })(
               <StyledSelect>
                 <Option key={"Contacted"} value={"Contacted"}>Contacted</Option>
                 <Option key={"No Answer"} value={"No Answer"}>No Answer</Option>
                 <Option key={"Pending"} value={"Pending"}>Pending</Option>
                 <Option key={"Quoted"} value={"Quoted"}>Quoted</Option>
                 <Option key={"Quote Sent"} value={"Quote Sent"}>Quote Sent</Option>
                 <Option key={"Sale"} value={"Sale"}>Sale</Option>
                 <Option key={"No Action"} value={"No Action"}>No Action</Option>
               </StyledSelect>
             )}
           </FormItem>
         </Col>
     
         {/* Assigned To (keep) */}
        
         {/* <Col
           xs={24}
           md={8}
           style={{
             padding: "1em",
             marginTop: window.innerWidth > 420 ? "" : "-2em",
           }}
         >
           <FormItem label={<span>Assigned To</span>}>
             {this.props.form.getFieldDecorator("assignedTo", {
               rules: [{ required: false, message: "Assigned To is required" }],
               initialValue: this.props.editStock ? this.props.editStock.assignedTo : "",
             })(
               <StyledSelect showSearch style={{ marginBottom: 15, width: "100%" }}>
                 {this.props.userOptions}
               </StyledSelect>
             )}
           </FormItem>
         </Col> */}
          <Col
           xs={24}
           md={8}
           style={{
             padding: "1em",
             marginTop: window.innerWidth > 420 ? "-1em" : "-2em",
           }}
         >
           <FormItem label={<span>Birth Date</span>}>
             {this.props.form.getFieldDecorator("birthdate", {
               rules: [{ required: false, message: "Birth Date is required" }],
               initialValue: this.props.editStock ? this.props.editStock.birthdate : "",
             })(
             <StyledInput size="large" placeholder="please enter a Birth Date" />
             )}
           </FormItem>
         </Col>
         {/* Hidden Date (keep) */}
        <Col
           xs={24}
           md={8}
           style={{
             padding: "1em",
             marginTop: window.innerWidth > 420 ? "-1em" : "-2em",
           }}
         >
           <FormItem label={<span>Date Added</span>}>
             {this.props.form.getFieldDecorator("timeDate", {
               rules: [{}],
               initialValue: this.state.curDT,
             })(<StyledInput disabled value={this.state.curDT} defaultValue={this.state.curDT} />)}
           </FormItem>
         </Col>
       </Row>
     
       {/* Quote lead details */}
       <Row style={{ marginTop: window.innerWidth > 420 ? "" : "-3em" }}>
         <Col xs={12} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Name & Surname</span>}>
             {this.props.form.getFieldDecorator("fullName", {
               rules: [{ required: false, message: "Name & Surname required" }],
               initialValue: this.props.editStock ? this.props.editStock.fullName : "",
             })(<StyledInput size="large" placeholder="please enter a name & surname" />)}
           </FormItem>
         </Col>
     
         <Col xs={12} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Contact Number</span>}>
             {this.props.form.getFieldDecorator("number", {
               rules: [{ required: false, message: "Contact Number required" }],
               initialValue: this.props.editStock ? this.props.editStock.number : "",
             })(<StyledInput size="large" placeholder="please enter a number" />)}
           </FormItem>
         </Col>
     
         <Col
           xs={24}
           md={8}
           style={{
             padding: "1em",
             marginTop: window.innerWidth > 420 ? "" : "-2em",
           }}
         >
           <FormItem label={<span>Email</span>}>
             {this.props.form.getFieldDecorator("email", {
               rules: [{ required: false, message: "Email required" }],
               initialValue: this.props.editStock ? this.props.editStock.email : "",
             })(<StyledInput size="large" placeholder="please enter an email" />)}
           </FormItem>
         </Col>
           <Col span={24} style={{ padding: "1em", marginTop: window.innerWidth > 420 ? "" : "-2em" }}>
           <FormItem label={<span>Address</span>}>
             {this.props.form.getFieldDecorator("address", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.address : "",
             })(<StyledInput size="large" placeholder="please enter an address" />)}
           </FormItem>
         </Col>
     
     {(() => {
       const coverType = (this.props.form.getFieldValue("hospitalCover") || "")
         .toString()
         .toLowerCase();
     
       const isInsurance = coverType.includes("insurance"); // also works if value is "Insurance - Life" etc.
     
       return !isInsurance ? (
         <>
         <Col
           xs={12}
           md={4}
           style={{
             padding: "1em",
             marginTop: window.innerWidth > 420 ? "" : "-2em",
           }}
         >
           <FormItem label={<span>Adult(s)</span>}>
             {this.props.form.getFieldDecorator("totalAdults", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.totalAdults : "",
             })(<StyledInput size="large" placeholder="nr. adults" />)}
           </FormItem>
         </Col>
     
         <Col
           xs={12}
           md={4}
           style={{
             padding: "1em",
             marginTop: window.innerWidth > 420 ? "" : "-2em",
           }}
         >
           <FormItem label={<span>Children</span>}>
             {this.props.form.getFieldDecorator("totalChildren", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.totalChildren : "",
             })(<StyledInput size="large" placeholder="nr. children" />)}
           </FormItem>
         </Col>
     
         {/* <Col
           xs={24}
           md={4}
           style={{
             padding: "1em",
             marginTop: window.innerWidth > 420 ? "" : "-2em",
           }}
         >
           <FormItem label={<span>Budget</span>}>
             {this.props.form.getFieldDecorator("budget", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.budget : "",
             })(
               <StyledInputNumber
                 placeholder="Approximate Monthly Budget"
                 style={{ width: "100%" }}
                 formatter={value => `R ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                 parser={value => value.replace(/\R\s?|(,*)/g, "")}
               />
             )}
           </FormItem>
         </Col> */}
     
         {/* <Col span={24} style={{ padding: "1em", marginTop: window.innerWidth > 420 ? "" : "-2em" }}>
           <FormItem label={<span>Package</span>}>
             {this.props.form.getFieldDecorator("package", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.package : "",
             })(<StyledInput size="large" placeholder="Package" />)}
           </FormItem>
         </Col> */}
     
       
         {/* NEW: Currently on medical aid */}
         <Col xs={24} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Currently on medical aid?</span>}>
             {this.props.form.getFieldDecorator("currentCover", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.currentCover : "",
             })(
               <StyledSelect>
                 <Option value="Yes">Yes</Option>
                 <Option value="No">No</Option>
               </StyledSelect>
             )}
           </FormItem>
         </Col>
     
         {/* NEW: Chronic conditions */}
         <Col xs={24} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Chronic conditions</span>}>
             {this.props.form.getFieldDecorator("healthConditions", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.healthConditions : "",
             })(<StyledInput size="large" placeholder="e.g. Diabetes, Hypertension..." />)}
           </FormItem>
         </Col>
     
         {/* NEW: Hospital care last 12 months */}
         <Col xs={24} md={8} style={{ padding: "1em" }}>
           <FormItem label={<span>Hospital care last 12 months?</span>}>
             {this.props.form.getFieldDecorator("recentCare", {
               rules: [{ required: false }],
               initialValue: this.props.editStock ? this.props.editStock.recentCare : "",
             })(
               <StyledSelect>
                 <Option value="Yes">Yes</Option>
                 <Option value="No">No</Option>
               </StyledSelect>
             )}
           </FormItem>
         </Col>
         </>
           ) : null;
     })()}
       </Row>
        <Row type="flex" justify="space-between" align="middle" />
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>{" "}
        {/*<Row type='flex' justify='space-around' align='middle'>
          <Button type='primary' onClick={this.props.onOk}>
            {this.props.okText}
          </Button>
          <Button type='primary' onClick={this.props.onCancel}>
            Cancel
          </Button>
        </Row>*/}
      </Form>
    );
  }
}
const StockForm = Form.create()(AddStockForm);

class Stock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      rejectReason: "",
      editStock: undefined,
      size: "large",
      flag: false,
      currentTab: "All",
    };
  }
  updateSignal;
  componentWillMount = () => {
    this.setState({ loading: true });
    this.props
      .findAllStock()
      .then(() => {
        let itemCodes = [];
        this.props.stock.forEach(stock => {
          if (stock.itemCode) {
            itemCodes.push(
              "Part: " + stock.itemCode + " - Location: " + stock.location
            );
          }
        });
        this.setState({ loading: false, itemCodes: itemCodes });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify("error", e);
      });
    this.updateSignal = {
      signal: msg => {
        this.props
          .findAllStock()
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  "Part: " + stock.itemCode + " - Location: " + stock.location
                );
              }
            });
            this.setState({ loading: false, itemCodes: itemCodes });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify("error", e);
          });
      },
    };
    window.pubnub.addListener(this.updateSignal);
    window.addEventListener("resize", this.resizeEvent);
    if (window.cordova) {
      document.addEventListener("backbutton", this.handleBack);
    }
  };
  handleBack = () => {
    if (this.state.previewVisible) {
      this.setState({ previewVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener("backbutton", this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  vehiclesForm;
  onAddStock = e => {
    this.setState({ previewVisible: true, editStock: undefined });
  };

  handleAddStock = e => {
    e.preventDefault();
    this.vehiclesForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        values.branchImage = this.vehiclesForm.state.branchImage;
        values.frontLeftImage = this.vehiclesForm.state.frontLeftImage;
        values.frontImage = this.vehiclesForm.state.frontImage;
        values.frontRightImage = this.vehiclesForm.state.frontRightImage;
        values.rightSideImage = this.vehiclesForm.state.rightSideImage;
        values.wheelsImage = this.vehiclesForm.state.wheelsImage;
        values.backRightImage = this.vehiclesForm.state.backRightImage;
        values.backImage = this.vehiclesForm.state.backImage;
        values.backLeftImage = this.vehiclesForm.state.backLeftImage;
        values.leftSideImage = this.vehiclesForm.state.leftSideImage;
        values.bootImage = this.vehiclesForm.state.bootImage;
        values.frontSeatImage = this.vehiclesForm.state.frontSeatImage;
        values.backSeatImage = this.vehiclesForm.state.backSeatImage;
        values.dashPassengerImage = this.vehiclesForm.state.dashPassengerImage;
        values.dashDriverImage = this.vehiclesForm.state.dashDriverImage;
        values.dashDriverSideImage = this.vehiclesForm.state.dashDriverSideImage;
        values.radioImage = this.vehiclesForm.state.radioImage;
        values.radioCloseImage = this.vehiclesForm.state.radioCloseImage;
        values.gearsImage = this.vehiclesForm.state.gearsImage;
        values.steeringImage = this.vehiclesForm.state.steeringImage;
        values.spareKeyImage = this.vehiclesForm.state.spareKeyImage;
        if (this.state.editStock) {
          values._id = this.state.editStock._id;
        }
        this.props
          .addStock(values)
          .then(() => {
            this.props
              .findAllStock()
              .then(() => {
                if (this.state.editStock) {
                  Notify("success", "Successfully saved lead");
                } else {
                  Notify("success", "Successfully added lead");
                }
                this.vehiclesForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  previewVisible: false,
                  editStock: undefined,
                  currentTab: "All",
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify("error", e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify("error", e);
          });
      }
    });
  };

  handleEditStock = e => {
    this.setState({ previewVisible: true, editStock: e });
  };

  handleDeleteStock = e => {
    const id = e.currentTarget.getAttribute("data");
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are you sure you want to delete this lead?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteStock(id)
          .then(() => {
            that.props
              .findAllStock()
              .then(() => {
                that.setState({
                  loading: false,
                  currentTab: "All",
                  previewVisible: false,
                });
                // that.props.find140mm();
                // that.props.find171mm();
                Notify("success", "Successfully deleted lead");
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify("error", e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify("error", e);
          });
      },
      oncancel() { },
    });
  };
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, sorter);
    this.setState({
      sortedInfo: sorter,
    });
  };
  handleSort = (pagination, filters, sorter) => {
    const columnKey = sorter.columnKey;
    const order = sorter.order;
    let stock = this.state.stock;

    stock.sort((a, b) => parseInt(b[columnKey]) - parseInt(a[columnKey]));
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? "black" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ""
      ),
  });

  renderCondition = (condition, color) => {
    return (
      <p style={{ margin: 0 }}>
        {/* <StyledBadge color={color} style={{}} /> */}
        {condition}
      </p>
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };

  render() {
    let descriptions = this.props.stock.map(vehicle => {
      return { value: vehicle.description };
    });
    const { condition } = this.state;
    const { stock } = this.props;
    let vehicles;

    vehicles = stock.filter(
      vehicle => vehicle.assignedTo === this.props.user.name
    );
    const dataSource = [
      {
        key: "1",
        name: "Mike",
        age: 32,
        address: "10 Downing Street",
      },
      {
        key: "2",
        name: "John",
        age: 42,
        address: "10 Downing Street",
      },
    ];

    const columns = [
      {
        title: "Year",
        dataIndex: "modelYear",
        key: "modelYear",
      },
      {
        title: "Make",
        dataIndex: "make",
        key: "make",
      },
      {
        title: "Model",
        dataIndex: "series",
        key: "series",
      },
      {
        title: "Derivative",
        dataIndex: "modelDesc",
        key: "modelDesc",
      },
      {
        title: "Condition",
        dataIndex: "condition",
        //key: "condition",
        render: condition => {
          switch (condition) {
            case "QUOTE REQUEST":
              return this.renderCondition("QUOTE REQUEST", "#4BED5B");
            case "YEAR PLAN":
              return this.renderCondition("YEAR PLAN", "lightgrey");
            case "12 WEEK PLAN":
              return this.renderCondition("12 WEEK PLAN", "blue");
            case "PREMIUM PLAN":
              return this.renderCondition("PREMIUM PLAN", "blue");
            default:
              return this.renderCondition("None", "lightgrey");
          }
        },
      },
      {
        title: "Price",
        dataIndex: "price",
        //key: "price",
        render: price => (
          <StyledInputNumber
            bordered={false}
            defaultValue={price}
            disabled
            formatter={price =>
              `R ${price}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={price => price.replace(/\R\s?|(,*)/g, "")}
          />
        ),
      },
      {
        title: "Actions",
        dataIndex: "actions",
        render: (text, stock) => (
          <span>
            <Button
              style={{
                backgroundColor: "black",
                color: "black",
                borderRadius: "3em",
              }}
              onClick={e => this.handleEditStock(stock)}
            >
              Edit
            </Button>
            <Divider type="vertical" />
            <DeleteFilled
              style={{
                backgroundColor: "#CFD5E3",
                color: "black",
                padding: "0.5em",
                borderRadius: "3em",
              }}
              data={stock._id}
              onClick={this.handleDeleteStock}
            />
          </span>
        ),
      },
    ];
    return (
      <div style={{ maxWidth: "90em", margin: "auto" }}>
        <Spin spinning={this.state.loading}>
          {this.state.previewVisible ? (
            <Card
              bordered={false}
              extra={
                <Title
                  style={{
                    fontSize: "29px",
                    fontWeight: 700,
                    blackSpace: "nowrap",
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {this.state.editStock
                    ? this.state.editStock.condition
                    : "Add Lead"}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: "15px",
                      blackSpace: "nowrap",
                      marginTop: "0.5em",
                      marginBottom: "0em",
                      color: "white",
                      textAlign: "center",
                    }}
                  >
                    {this.state.editStock
                      ? "Please click save to edit lead"
                      : "Fill in all fields and click save to add a new lead"}
                  </p>
                </Title>
              }
              style={{
                margin: "auto",
                maxWidth: "60em",
                paddingBottom: window.innerWidth > 420 ? "" : "7em",
                // textAlign: "center",
                marginTop: "3em",
                // backgroundColor: "#5F5D60",
                borderRadius: "0.8em",
                boxShadow: "0px 6px 15px 0px rgba(0, 0, 0, 0.08)",
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: "auto",
                }}
              >
                <StockForm
                  descriptions={descriptions}
                  editStock={this.state.editStock}
                  wrappedComponentRef={form => (this.vehiclesForm = form)}
                />
                <Tooltip placement="left" title="Save Lead">
                  <Button
                    type="primary"
                    shape="round"
                    onClick={this.handleAddStock}
                    size="large"
                    style={{
                      position: "fixed",
                      bottom: window.innerWidth > 420 ? "6.5em" : "8.5em",
                      right: "1em",
                      fontSize: "14px",
                      width: "4em",
                      height: "4em",
                      //height: "3em",
                      marginLeft: "0.7em",
                    }}
                  >
                    <CheckOutlined />
                  </Button>
                </Tooltip>
                <Tooltip placement="left" title="Cancel">
                  <Button
                    shape="round"
                    onClick={e => this.setState({ previewVisible: false })}
                    style={{
                      fontSize: "14px",
                      width: "4em",
                      height: "4em",
                      position: "fixed",
                      bottom: window.innerWidth > 420 ? "2em" : "4em",
                      right: "1em",
                      border: "1px solid #EEEFF0",
                      backgroundColor: "lightgrey",
                    }}
                  >
                    <CloseOutlined />
                  </Button>
                </Tooltip>
              </div>
            </Card>
          ) : (
            <Row>
              <Col span={24}>
                <StyledTabs
                  style={{ marginTop: "1em" }}
                  defaultActiveKey="1"
                  onChange={this.changeTypeTab}
                  tabBarExtraContent={
                    {
                      // left: (
                      //   <Button
                      //     type="primary"
                      //     shape="round"
                      //     onClick={this.onAddStock}
                      //     icon={
                      //       <PlusCircleOutlined style={{ fontSize: "110%" }} />
                      //     }
                      //     size="large"
                      //     style={{
                      //       marginRight: "2.5em",
                      //       height: "3em",
                      //       width: "10em",
                      //       backgroundColor: "rgb(95, 93, 96)",
                      //       borderColor: "rgb(95, 93, 96)",
                      //     }}
                      //   >
                      //     Add Lead
                      //   </Button>
                      // ),
                      // right: (
                      //   <h1 style={{ color: "#656565", fontSize: 22 }}>
                      //     Clients
                      //     <span style={{ color: "#1890ff", fontSize: 25 }}>
                      //       : {this.props.stock.length}
                      //     </span>
                      //   </h1>
                      // ),
                    }
                  }
                >
                  <TabPane tab="All" key="All">
                                  <StyledTable
                    bordered={false}
                    dataSource={vehicles.slice().sort((a, b) => b - a).reverse()}
                    rowKey={record => record._id}
                    size="middle"
                    pagination={{ defaultPageSize: 45 }}
                    style={{ minWidth: "15em", marginTop: "0.5em" }}
                    expandedRowRender={
                      window.innerWidth <= 420
                        ? (record) => (
                            <Card size="small" title={record.fullName}>
                              <p>Email: {record.email}</p>
                              <p>Number: {record.number}</p>
                              <p>Handled By: {record.assignedTo}</p>
                              <p>Lead Type: {record.hospitalCover}</p>
                              <p>Status: {record.status}</p>
                            </Card>
                          )
                        : null
                    }
                    onRow={(record) => ({
                      onClick: (e) => {
                        e.stopPropagation();
                        this.handleEditStock(record);
                      },
                    })}
                  >
                    <Column
                      {...this.getColumnSearchProps("fullName")}
                      title="Name & Surname"
                      dataIndex="fullName"
                      key="fullName"
                    />
                  
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("email")}
                        title="Email"
                        dataIndex="email"
                        key="email"
                        render={(text, stock) => (
                          <a style={{ color: "black" }} href={"mailto:" + stock.email}>
                            {stock.email}
                          </a>
                        )}
                      />
                    ) : null}
                  
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("number")}
                        title="Phone"
                        dataIndex="number"
                        key="number"
                        render={(text, stock) => (
                          <a style={{ color: "black" }} href={"tel:" + stock.number}>
                            {stock.number}
                          </a>
                        )}
                      />
                    ) : null}
                  
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("assignedTo")}
                        title="Handled by"
                        dataIndex="assignedTo"
                        key="assignedTo"
                        render={(text, stock) => (
                          <a style={{ color: "black" }}>
                            {stock.assignedTo ? stock.assignedTo : "Admin"}
                          </a>
                        )}
                      />
                    ) : null}
                  
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("hospitalCover")}
                        title="Lead Type"
                        dataIndex="hospitalCover"
                      
                      />
                    ) : null}
                  
                    <Column
                      {...this.getColumnSearchProps("status")}
                      title="Status"
                      dataIndex="status"
                      key="status"
                      render={(text, stock) => (
                        <span>
                          {stock.status === "Contacted" ? (
                            <Tag color="green" key="Contacted">Contacted</Tag>
                          ) : stock.status === "No Answer" ? (
                            <Tag color="red" key="No Answer">No Answer</Tag>
                          ) : stock.status === "Sale" ? (
                            <Tag color="green" key="Sale">Sale</Tag>
                          ) : stock.status === "Quoted" ? (
                            <Tag color="yellow" key="Quoted">Quoted</Tag>
                          ) : stock.status === "Quote Sent" ? (
                            <Tag color="green" key="Quote Sent">Quote Sent</Tag>
                          ) : stock.status === "Pending" ? (
                            <Tag color="orange" key="Pending">Pending</Tag>
                          ) : (
                            <Tag color="red" key="No Action">No Action</Tag>
                          )}
                        </span>
                      )}
                    />
                  
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("timeDate")}
                        title="Date Updated"
                        dataIndex="timeDate"
                        key="timeDate"
                      />
                    ) : null}
                  
                    <Column
                      title="Actions"
    render={(text, stock) => (
      <span>
        {window.innerWidth > 420 ? (
          <Button
            style={{
              backgroundColor: "rgb(95, 93, 96)",
              color: "white",
              borderRadius: "3em",
            }}
            onClick={(e) => {
              e.stopPropagation();
              this.handleEditStock(stock);
            }}
          >
            Edit
          </Button>
        ) : null}
        <Divider type="vertical" />
        <DeleteFilled
          style={{
            backgroundColor: "rgb(201, 79, 79)",
            color: "white",
            padding: "0.5em",
            borderRadius: "3em",
          }}
          data={stock._id}
          onClick={this.handleDeleteStock}
        />
      </span>
    )}
  />
</StyledTable>
                  </TabPane>
                  {/* <TabPane tab="QUOTE REQUEST" key="QUOTE REQUEST">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('eventTitle')}
                        title="Name & Surname"
                        dataIndex="eventTitle"
                        key="eventTitle"
                      />
                      <Column
                        {...this.getColumnSearchProps('timeDate')}
                        title="Time Stamp"
                        dataIndex="timeDate"
                        key="timeDate"
                      />

                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Category"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'QUOTE REQUEST':
                              return this.renderCondition(
                                'QUOTE REQUEST',
                                '#4BED5B'
                              );
                            case 'YEAR PLAN':
                              return this.renderCondition('YEAR PLAN', 'lightgrey');
                            case '12 WEEK PLAN':
                              return this.renderCondition('12 WEEK PLAN', 'blue');
                            case 'PREMIUM PLAN':
                              return this.renderCondition('PREMIUM PLAN', 'blue');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: 'black',
                                color: 'black',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'black',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>
                  <TabPane tab="YEAR PLAN" key="YEAR PLAN">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                      onChange={this.handleSort}
                    >
                      <Column
                        {...this.getColumnSearchProps('eventTitle')}
                        title="Name & Surname"
                        dataIndex="eventTitle"
                        key="eventTitle"
                      />
                      <Column
                        {...this.getColumnSearchProps('timeDate')}
                        title="Time Stamp"
                        dataIndex="timeDate"
                        key="timeDate"
                      />

                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Category"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'QUOTE REQUEST':
                              return this.renderCondition(
                                'QUOTE REQUEST',
                                '#4BED5B'
                              );
                            case 'YEAR PLAN':
                              return this.renderCondition('YEAR PLAN', 'lightgrey');
                            case '12 WEEK PLAN':
                              return this.renderCondition('12 WEEK PLAN', 'blue');
                            case 'PREMIUM PLAN':
                              return this.renderCondition('PREMIUM PLAN', 'blue');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: 'black',
                                color: 'black',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'black',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>
                  <TabPane tab="12 WEEK PLAN" key="12 WEEK PLAN">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('eventTitle')}
                        title="Name & Surname"
                        dataIndex="eventTitle"
                        key="eventTitle"
                      />
                      <Column
                        {...this.getColumnSearchProps('timeDate')}
                        title="Time Stamp"
                        dataIndex="timeDate"
                        key="timeDate"
                      />

                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Category"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'QUOTE REQUEST':
                              return this.renderCondition(
                                'QUOTE REQUEST',
                                '#4BED5B'
                              );
                            case 'YEAR PLAN':
                              return this.renderCondition('YEAR PLAN', 'lightgrey');
                            case '12 WEEK PLAN':
                              return this.renderCondition('12 WEEK PLAN', 'blue');
                            case 'PREMIUM PLAN':
                              return this.renderCondition('PREMIUM PLAN', 'blue');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: 'black',
                                color: 'black',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'black',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>
                  <TabPane tab="PREMIUM PLAN" key="PREMIUM PLAN">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('eventTitle')}
                        title="Name & Surname"
                        dataIndex="eventTitle"
                        key="eventTitle"
                      />
                      <Column
                        {...this.getColumnSearchProps('timeDate')}
                        title="Time Stamp"
                        dataIndex="timeDate"
                        key="timeDate"
                      />

                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Category"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'QUOTE REQUEST':
                              return this.renderCondition(
                                'QUOTE REQUEST',
                                '#4BED5B'
                              );
                            case 'YEAR PLAN':
                              return this.renderCondition('YEAR PLAN', 'lightgrey');
                            case '12 WEEK PLAN':
                              return this.renderCondition('12 WEEK PLAN', 'blue');
                            case 'PREMIUM PLAN':
                              return this.renderCondition('PREMIUM PLAN', 'blue');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: 'black',
                                color: 'black',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'black',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane> */}
                  {/*
                  <TabPane tab="Demo" key="Demo">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      //columns={columns}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('vehicleStockNumber')}
                        title="Stock Number"
                        dataIndex="vehicleStockNumber"
                        key="vehicleStockNumber"
                      />
                      <Column
                        {...this.getColumnSearchProps('modelYear')}
                        title="Year"
                        dataIndex="modelYear"
                        key="modelYear"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('make')}
                        title="Make"
                        dataIndex="make"
                        key="make"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('series')}
                        title="Model"
                        dataIndex="series"
                        key="series"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('modelDesc')}
                        title="Derivative"
                        dataIndex="modelDesc"
                        key="modelDesc"
                      />
                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Condition"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'New':
                              return this.renderCondition('New', '#4BED5B');
                            case 'Used':
                              return this.renderCondition('Used', '#EE4C4C');
                            case 'Demo':
                              return this.renderCondition('Demo', '#FF8F28');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: 'black',
                                color: 'black',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'black',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane> */}
                </StyledTabs>
              </Col>
            </Row>
          )}
        </Spin>
      </div>
    );
  }
}

const WrappedStock = Form.create()(Stock);
export default WrappedStock;
